const demoContent = (canvas, fabric, imageList) => {
    if (imageList) {
        imageList.sort((a, b) => {
            return a.serial - b.serial
        })
        let leftSpace = 200
        let index = 0
        for (const item of imageList) {
            fabric.Image.fromURL(
                `${item.src}?x-${
                    Math.floor(Math.random() * 1000000000) + 1
                }=html`,
                function (oImg) {
                    if (imageList.length === 1) {
                        oImg.scaleToWidth(850)
                    } else {
                        index++
                        oImg.scaleToHeight(400)
                        oImg.scaleToWidth(400)
                        canvas.centerObjectH(oImg)
                        const left = oImg.left
                        if (index === 1) {
                            leftSpace = leftSpace + left - 450
                        } else {
                            leftSpace = left + 250
                        }
                        oImg.set({ left: leftSpace })
                    }
                    if (imageList.length === 1) {
                        canvas.centerObject(oImg)
                    } else {
                        canvas.centerObjectV(oImg)
                    }
                    canvas.add(oImg)
                    canvas.fire('object:modified')
                },
                { crossOrigin: 'Anonymous' }
            )
        }
    }
}

export default demoContent
